import { render, staticRenderFns } from "./PasswordRecoverySent.vue?vue&type=template&id=5ccc0931"
import script from "./PasswordRecoverySent.vue?vue&type=script&lang=ts"
export * from "./PasswordRecoverySent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports